<script setup>
  import useSecureUrls from '@/composables/useSecureUrls';

  const { signinUrl, upgradeUrl } = useSecureUrls();

  const SIGNIN_URL = signinUrl({ rd: 'en-us/Alerts/ViewAlerts.aspx' });
  const CREATE_ACCOUNT_URL = upgradeUrl;
</script>

<template>
  <div class="jwx-page jwx-h-100">
    <div class="jwx-page__container jwx-h-100" data-section-gap="true">
      <header class="jwx-toolbar-header">
        <div class="jwx-toolbar-header__main-content">
          <div class="jwx-toolbar-header__title">
            <h2 class="jwx-toolbar-header__title-text">Alerts</h2>
          </div>
        </div>
      </header>
      <div class="jwx-grid jwx-place-content-center jwx-h-100">
        <p class="jwx-text jwx-font-size-lg jwx-text-center jwx-p-jumbo" style="background-color: var(--jwx-surface-level-1); border-radius: 100px;">
          <a :href="SIGNIN_URL">Sign in</a> or <a :href="CREATE_ACCOUNT_URL">create a free account</a> to start setting up wind alerts.
        </p>
      </div>
    </div>
  </div>
</template>
